var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCornellNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 175C59.1775 175 25.6001 141.423 25.6001 100C25.6001 58.5774 59.1775 25 100.6 25C142.023 25 175.6 58.5774 175.6 100C175.6 141.423 142.023 175 100.6 175Z",
    fill: "url(#paint0_linear_26801_54)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.859 48.2886C150.31 47.5363 149.617 46.9003 148.821 46.4175C148.025 45.9346 147.14 45.6145 146.22 45.4756L55.0815 31.5732C53.2226 31.2929 51.3284 31.7609 49.8139 32.8747C48.2995 33.9884 47.2882 35.6571 47.0018 37.515L31.6747 137.999C31.4041 139.856 31.8758 141.746 32.9876 143.258C34.0994 144.771 35.762 145.784 37.6156 146.08L111.089 157.287C114.329 157.784 117.635 157.636 120.819 156.854C124.002 156.071 127 154.669 129.641 152.727C132.282 150.785 134.515 148.341 136.211 145.536C137.907 142.73 139.033 139.618 139.526 136.377L152.159 53.5555C152.301 52.6352 152.259 51.6959 152.036 50.7919C151.813 49.8878 151.413 49.037 150.859 48.2886Z",
    fill: "url(#paint1_linear_26801_54)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.556 162.557C148.225 162.58 143.166 163.242 135.791 164.211C114.729 166.977 74.9688 172.225 73.9287 172.225C72.21 172.22 70.5512 171.592 69.2602 170.458C67.9691 169.323 67.1334 167.759 66.908 166.055L53.7885 65.2597C53.5611 63.3944 54.0754 61.5144 55.2204 60.0244C56.3655 58.5345 58.0499 57.5538 59.911 57.2935L151.322 45.4033C153.182 45.1681 155.06 45.6768 156.548 46.8189C158.035 47.9609 159.011 49.644 159.264 51.502L168.743 124.238L170.091 134.592C170.938 141.155 169.146 147.786 165.108 153.029C161.071 158.272 155.118 161.699 148.556 162.557Z",
    fill: "url(#paint2_linear_26801_54)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.556 162.557C148.225 162.58 143.166 163.242 135.791 164.211C136.838 159.772 137.369 155.227 137.375 150.666C134.656 138.28 141.653 127.146 155.577 127.122C157.279 126.886 163.945 125.538 168.743 124.238L170.091 134.592C170.938 141.155 169.146 147.786 165.108 153.029C161.071 158.272 155.118 161.699 148.556 162.557Z",
    fill: "#6183E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.518 45.1937L109.311 59.4022C107.115 61.5374 110.514 64.9509 112.653 62.7449L126.86 48.5362C127.783 47.6129 124.441 44.2701 123.518 45.1937Z",
    fill: "#0C1F56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.109 37.3934C145.111 36.643 144.964 35.8997 144.677 35.2064C144.39 34.5132 143.968 33.8838 143.435 33.3548L138.7 28.6188C137.612 27.5798 136.166 27 134.661 27C133.157 27 131.71 27.5798 130.622 28.6188L126.175 33.0661C124.186 32.8504 122.176 33.1133 120.31 33.8329C118.444 34.5525 116.778 35.708 115.449 37.2029C115.023 37.6495 114.788 38.2453 114.795 38.8629C114.802 39.4804 115.051 40.0707 115.487 40.5074L131.547 56.5675C131.995 57.0098 132.599 57.2568 133.228 57.2544C133.857 57.252 134.46 57.0004 134.904 56.5547C136.293 55.2099 137.364 53.5709 138.037 51.7581C138.71 49.9453 138.968 48.0047 138.793 46.079L143.436 41.4342C143.968 40.9048 144.39 40.2751 144.678 39.5815C144.965 38.8878 145.111 38.1441 145.109 37.3934Z",
    fill: "url(#paint3_linear_26801_54)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8131 96.255C71.2226 96.2388 70.6594 96.0026 70.2341 95.5926C69.8088 95.1826 69.552 94.6284 69.5141 94.0389C69.4763 93.4494 69.6601 92.867 70.0295 92.4059C70.3988 91.9449 70.9272 91.6385 71.5108 91.5469L148.865 81.4717C149.173 81.4315 149.486 81.4523 149.785 81.533C150.085 81.6137 150.366 81.7527 150.612 81.942C150.858 82.1313 151.065 82.3672 151.22 82.6362C151.375 82.9052 151.475 83.2022 151.515 83.51C151.555 83.8179 151.534 84.1306 151.454 84.4304C151.373 84.7302 151.234 85.0112 151.045 85.2572C150.856 85.5033 150.62 85.7097 150.351 85.8646C150.082 86.0196 149.785 86.12 149.477 86.1601L72.1225 96.2354C72.0199 96.2489 71.9166 96.2554 71.8131 96.255Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_26801_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.3968 78.3195C80.8064 78.303 80.2434 78.0665 79.8182 77.6564C79.3931 77.2464 79.1365 76.6922 79.0988 76.1028C79.0611 75.5133 79.245 74.931 79.6144 74.4701C79.9838 74.0092 80.5121 73.7029 81.0957 73.6113L135.01 66.5907C135.632 66.5098 136.26 66.6793 136.757 67.0618C137.253 67.4443 137.578 68.0085 137.659 68.6302C137.74 69.2519 137.57 69.8803 137.188 70.3771C136.805 70.8738 136.241 71.1983 135.619 71.2791L81.7058 78.2998C81.6033 78.3133 81.5001 78.3199 81.3968 78.3195Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_26801_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9508 112.664C73.3603 112.648 72.7971 112.411 72.3718 112.001C71.9465 111.591 71.6897 111.037 71.6518 110.448C71.614 109.858 71.7978 109.276 72.1672 108.815C72.5365 108.354 73.0649 108.047 73.6485 107.956L151.003 97.8812C151.311 97.841 151.623 97.8619 151.923 97.9426C152.223 98.0233 152.504 98.1622 152.75 98.3515C152.996 98.5408 153.202 98.7767 153.357 99.0457C153.512 99.3148 153.613 99.6117 153.653 99.9196C153.693 100.227 153.672 100.54 153.591 100.84C153.511 101.14 153.372 101.421 153.183 101.667C152.993 101.913 152.757 102.119 152.488 102.274C152.219 102.429 151.922 102.53 151.614 102.57L74.2595 112.644C74.1572 112.658 74.054 112.664 73.9508 112.664Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_26801_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0885 129.072C75.498 129.056 74.9348 128.82 74.5095 128.41C74.0842 128 73.8274 127.446 73.7895 126.856C73.7517 126.267 73.9355 125.684 74.3049 125.223C74.6742 124.762 75.2026 124.456 75.7862 124.364L153.139 114.289C153.761 114.208 154.389 114.377 154.886 114.759C155.383 115.142 155.708 115.706 155.789 116.327C155.87 116.949 155.701 117.578 155.319 118.075C154.937 118.572 154.373 118.896 153.751 118.978L76.3979 129.053C76.2953 129.066 76.192 129.073 76.0885 129.072Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_26801_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2249 145.481C77.6345 145.465 77.0715 145.228 76.6464 144.818C76.2212 144.408 75.9647 143.854 75.927 143.264C75.8892 142.675 76.0731 142.093 76.4425 141.632C76.812 141.171 77.3402 140.864 77.9238 140.773L101.365 137.72C101.987 137.639 102.615 137.809 103.112 138.191C103.609 138.574 103.933 139.138 104.014 139.759C104.095 140.381 103.925 141.01 103.543 141.506C103.16 142.003 102.596 142.328 101.974 142.408C101.553 142.442 78.6091 145.491 78.2249 145.481Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_54",
    x: 69.5093,
    y: 80.4518,
    width: 82.0256,
    height: 15.8032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_54",
    result: "effect2_innerShadow_26801_54"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_26801_54",
    x: 79.094,
    y: 65.5709,
    width: 58.5845,
    height: 12.7485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_54",
    result: "effect2_innerShadow_26801_54"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_26801_54",
    x: 71.647,
    y: 96.8613,
    width: 82.0256,
    height: 15.8026,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_54",
    result: "effect2_innerShadow_26801_54"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_26801_54",
    x: 73.7847,
    y: 113.269,
    width: 82.0247,
    height: 15.8032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_54",
    result: "effect2_innerShadow_26801_54"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_26801_54",
    x: 75.9221,
    y: 136.7,
    width: 28.1116,
    height: 8.78076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_54"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_54",
    result: "effect2_innerShadow_26801_54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_54",
    x1: 25.6001,
    y1: 36.7188,
    x2: 168.569,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_54",
    x1: 128.1,
    y1: 150.5,
    x2: 88.1127,
    y2: 19.5454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_54",
    x1: 112.016,
    y1: 45.347,
    x2: 112.016,
    y2: 172.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_54",
    x1: 118.111,
    y1: 27,
    x2: 153.127,
    y2: 48.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornellNotes);
export default __webpack_public_path__ + "static/media/Cornell-Notes.2016d43ca632a1db08e27af4ab85ad11.svg";
export { ForwardRef as ReactComponent };